import { render, staticRenderFns } from "./NewAdminDashbord.vue?vue&type=template&id=4c55a37a&scoped=true"
import script from "./NewAdminDashbord.vue?vue&type=script&lang=js"
export * from "./NewAdminDashbord.vue?vue&type=script&lang=js"
import style0 from "./NewAdminDashbord.vue?vue&type=style&index=0&id=4c55a37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55a37a",
  null
  
)

export default component.exports